
<mat-accordion class="custom-accordion box-appearance background" multi="false">
  <div *ngFor="let group of checklistModel.groups">

    <mat-expansion-panel *ngIf="group.steps.length + group.notes.length > 0"
                         [expanded]="group.isExpanded"
                         hideToggle>
      <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
        <mat-panel-title>
          <span>{{ group.title }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="contents-container">
        <div class="notes" *ngFor="let note of group.notes">
          <div  *ngIf="isNoteOnTop(note)" [innerHTML]="note.text | apiColourHtml"></div>
        </div>

        <ul class="help-and-support-list bulletpoint">
          <li *ngFor="let step of group.steps">
            <div class="p-l-18" [innerHTML]="step.text | apiColourHtml"></div>
            <div *ngIf="step.note" class="notes" [innerHTML]="step.note.text | apiColourHtml"></div>
          </li>
        </ul>

        <div class="notes" *ngFor="let note of group.notes">
          <div *ngIf="isNoteAtBottom(note)" [innerHTML]="note.text | apiColourHtml"></div>
        </div>
      </div>

    </mat-expansion-panel>

  </div>
</mat-accordion>
